import { Component, ElementRef, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import { EmitterService } from 'app/core/utility/services/emitter.service';
import * as jQuery from 'jquery';

@Component({
	selector: 'app-audio-player',
	templateUrl: './audio-player.component.html',
	styleUrls: ['./audio-player.component.css']
})
export class AudioPlayerComponent implements OnInit {
	@Input() audioURL: string;
	@ViewChild('audioPlayer', { static: true }) audioPlayer: any;
	public selectedVideoSubscription: any;

	constructor(private renderer: Renderer2) {
		this.selectedVideoSubscription = EmitterService.get('PLAY_SELECTED_VIDEO').subscribe((creative) => {
			setTimeout(() => {
				if (creative && (creative.isAudioCreative || creative.audioURL)) {
					if (this.audioURL !== creative.audioURL) {
						this.audioPlayer.nativeElement.pause();
					} else {
						this.audioPlayer.nativeElement.play();
					}
					this.audioPlayer.nativeElement.muted = true;
					this.audioPlayer.nativeElement.currentTime = 0;
				}
			});
		});
	}

	ngOnInit(): void {
		this.enableAutoPlayOnFlag(true);
	}

	enableAutoPlayOnFlag(enable: boolean): void {
		if (this.audioPlayer.nativeElement) {
			this.audioPlayer.nativeElement.autoplay = enable;
			this.audioPlayer.nativeElement.muted = true;
		}
	}
}
